import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import SelectClientServicesModal
  from '@screens/admin/operations/executions/addExecutions/steps/SelectClientServices.modal';
import ClientServicesExecutionsModal
  from '@screens/admin/operations/executions/addExecutions/steps/ClientServicesExecutions.modal';
import {ClientsService} from '@store/clients/services';
import SelectClientContractsModal
  from '@screens/admin/operations/executions/addExecutions/steps/SelectClientContracts.modal';
import {ClientsContract} from '@store/clients/contracts';

export enum AddBatchProvenance {
  EXEC = 'EXEC',
  EXEC_LINE = 'EXEC_LINE'
}

const AddBatchExecutionsIndex = ({from}: { from: AddBatchProvenance }) => {
  const navigate = useNavigate();

  const [step, setStep] = useState(0);

  const [executionDate, setExecutionDate] = useState<Date | undefined>(undefined);
  const [clientContracts, setClientContracts] = useState<ClientsContract[]>([]);
  const [clientServices, setClientServices] = useState<{ quantity: number; service: ClientsService }[]>([]);

  const handleClose = () => navigate('..', {replace: true});


  switch (step) {
    case 0:
      return (
        <SelectClientContractsModal
          from={from}
          handleClose={handleClose}
          handleValidate={(selectedClientContracts) => {
            setClientContracts(selectedClientContracts);
            setStep((state) => state + 1);
          }
          }/>
      );
    case 1:
      return (
        <SelectClientServicesModal
          from={from}
          handleClose={handleClose}
          handleBack={() => setStep(0)}
          clientsContracts={clientContracts}
          handleValidate={(selectedClientServices, date) => {
            setClientServices(selectedClientServices);
            setExecutionDate(date);
            setStep((state) => state + 1);
          }}/>
      );
    case 2:
      return (
        <ClientServicesExecutionsModal
          executionDate={executionDate}
          clientServices={clientServices}
          handleClose={handleClose}
          handleBack={() => setStep(1)}
        />
      );
    default:
      return null;
  }
};

export default AddBatchExecutionsIndex;
